import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { exists } from '../../../../../../../../functions/exists';
import type { VariantsGroupedByBrand } from '../../../../../../models/variants-grouped-by-brand';
import type { DougShelfTalkerCardData } from '../../../../../../../../models/shelf-talkers/doug-shelf-talker-card-data';
import { ShelfTalkerCardContentViewModel } from '../../shelf-talker-card-content-view-model';

@Injectable()
export class DougShelfTalkerContentViewModel extends ShelfTalkerCardContentViewModel {
  override data$: Observable<DougShelfTalkerCardData | null>;
  public headerTextColor$ = this.data$.pipe(map(data => data?.getHeaderTextColor() || '#ffffff'));
  public accentColor$ = this.data$.pipe(map(data => data?.getAccentColor() || '#222222'));

  public readonly variantsGroupedByBrandThenSorted$ = this.data$.pipe(
    map(data => data?.getVariantsGroupedByBrandThenSortedBySectionSpecifications()),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly variantsSplitInto6Rows$ = this.variantsGroupedByBrandThenSorted$.pipe(
    map(sortedByBrand => {
      const twoListsPerRow: [VariantsGroupedByBrand, VariantsGroupedByBrand][] = [];
      for (let i = 0; i < sortedByBrand.length; i += 2) {
        const first = sortedByBrand?.[i];
        const second = sortedByBrand?.[i + 1] ?? null;
        if (exists(first) || exists(second)) {
          twoListsPerRow.push([first, second]);
        }
      }
      return twoListsPerRow?.take(6);
    })
  );
}
